<template>
  <Modal
    v-if="settings.show"
    title="Warning!"
    submit-btn-text="Cancel"
    delete-btn-text="Continue Anyway"
    :width="500"
    @submit="handleCancel"
    @delete="handleConfirm"
    @hide-modal="handleCancel"
  >
    <div class="form-group mb-0">
      <WarningMessage>You are making changes to a closed job.</WarningMessage>
      <p class="mb-4">
        Just a reminder that we don’t recommend making changes to closed jobs.
        If you expect any future work or updates, it’s a good idea to update the
        job status first.
      </p>
      <p class="mb-4">
        If you decide to proceed, your changes will be saved, but keep in mind
        that the job status won’t be adjusted automatically.
      </p>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import WarningMessage from "serviceshift-ui/components/General/WarningMessage.vue";
import { computed } from "vue";
import { useStore } from "vuex";

import Modal from "@/components/Modal.vue";

const store = useStore();
const settings = computed(() => {
  return store.state.jobStatusFinalWarning;
});

const handleCancel = () => {
  store.dispatch("cancelJobStatusFinalWarning");
};

const handleConfirm = () => {
  store.dispatch("confirmJobStatusFinalWarning");
};
</script>

<style lang="scss" scoped></style>
